import { LocalDictionaryFactory } from "../../api/api.module"
import { LoggerService } from "../../common/common.module"

import { GRID_SERVICE_NAME, GridService } from "../../../services/grid"
import { OPERATOR_GROUP_TECHNICAL_PERMISSIONS_SERVICE_NAME, OperatorGroupTechnicalPermissionsService, OperatorGroupOperatorsService, OPERATOR_GROUP_OPERATORS_SERVICE_NAME } from '../../../services/operator-group'
import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeService } from '../../../services/reference-type'
import { TECHNICAL_PERMISSION_SERVICE_NAME, TechnicalPermissionService } from "../../../services/technical-permission"
import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../../../services/user-session"

import { OperatorGroupDetailsController } from "./operator-group-details.controller"
import { OperatorGroupHelper } from "../operator-group-helper"

//#region Asset Imports

import './operator-group-details.scss'
import * as TEMPLATE from './operator-group-details.tpl.html'

//#endregion

// #region Consts

const TEMPLATE_PATH: string = `./${OperatorGroupHelper.FILE_NAME_PREFIX}-details.tpl.html`

// #endregion


// #region Setup

export class OperatorGroupDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        '$scope',
        '$q',
        '$timeout',
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        TECHNICAL_PERMISSION_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        OPERATOR_GROUP_OPERATORS_SERVICE_NAME,
        OPERATOR_GROUP_TECHNICAL_PERMISSIONS_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSessionService: UserSessionService,
            gridService: GridService,
            technicalPermissionService: TechnicalPermissionService,
            referenceTypeService: ReferenceTypeService,
            opreatorGroupOperatorsService: OperatorGroupOperatorsService,
            operatorGroupTechnicalPermissionsService: OperatorGroupTechnicalPermissionsService
        ) => new OperatorGroupDetailsController(
            $scope,
            $q,
            $timeout,
            logger,
            localDictionary,
            userSessionService,
            gridService,
            technicalPermissionService,
            referenceTypeService,
            opreatorGroupOperatorsService,
            operatorGroupTechnicalPermissionsService,
            OperatorGroupHelper.REFERENCE_TYPE,
            OperatorGroupHelper.SIMAX_MODULE_NAME
        )
    ]

    template = TEMPLATE
}

// #endregion